import React from 'react';
import { excludedRowsCopy, MIXED_OWNERS_COPY } from '../../utils/isolationCopy';

// Run-panel twin of the report's owner-scope limits (docs/signoff-report-template.md §5).
// `scope` is the proxy's { owners[], mixedOwners, excludedUnownedOwnRows } on a rollup/run;
// older proxies send none, which renders nothing. The excluded line is omitted when 0.
export default function RunScopeNotes({ scope, unsignableReason }) {
  const mixed = (scope && scope.mixedOwners === true) || unsignableReason === 'mixed_owners';
  const excluded = excludedRowsCopy(scope && scope.excludedUnownedOwnRows);
  if (!mixed && !excluded) return null;
  const style = { fontSize: 12, padding: '6px 10px', marginBottom: 8, borderRadius: 7, background: 'var(--warn-bg)', color: 'var(--ink)', border: '1px solid var(--line)' };
  return (
    <div data-testid="run-scope-notes">
      {mixed && <div data-testid="run-mixed-owners" style={style}>{MIXED_OWNERS_COPY}</div>}
      {excluded && <div data-testid="run-excluded-rows" style={style}>{excluded}</div>}
    </div>
  );
}
